// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"a2c128512e7272e2602a","396":"158ded060037e11e00ea","562":"12816a740fb7004cd7a1","812":"246bfa8d291bb093aef6"}[chunkId] + ".chunk.js";
};